import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Slider from '@ant-design/react-slick';
import 'slick-carousel/slick/slick.css';
import 'antd/dist/antd.min.css';
import Spin from '@iso/ui/Antd/Spin/Spin';
import { Helmet } from 'react-helmet';

import { useParams } from 'react-router-dom';
import IntlMessages from '@iso/components/utility/intlMessages';
import LocalEatzWrapper from './LocalEats.styles';

import PromotionItem from '@iso/components/LocalEats/promotion/PromotionItem';
import CategoryItem from '@iso/components/LocalEats/category/CategoryItem';
import CategoryItemCity from '@iso/components/LocalEats/category/CategoryItemCity';
import RestaurantItem from '@iso/components/LocalEats/restaurant/RestaurantItem';
import Footer from '@iso/components/LocalEats/footer/Footer';

import LanguageSwitcher from '@iso/components/LocalEats/language/LanguageSwitcher';

import categoryImg from '@iso/assets/images/localeats/category/1.png';
import categoryImg1 from '@iso/assets/images/localeats/category/2.png';
import categoryImg2 from '@iso/assets/images/localeats/category/3.png';
import categoryImg3 from '@iso/assets/images/localeats/category/4.png';
import categoryImg4 from '@iso/assets/images/localeats/category/5.png';
import categoryImg5 from '@iso/assets/images/localeats/category/6.png';
import categoryImg6 from '@iso/assets/images/localeats/category/7.png';

import cityArr from './CountryItemArray';

import cardViewImage1 from '@iso/assets/images/localeats/card-view-switcher/card-view-1.svg';
import cardViewImage2 from '@iso/assets/images/localeats/card-view-switcher/card-view-2.svg';
import cardViewImage3 from '@iso/assets/images/localeats/card-view-switcher/card-view-3.svg';
import localEatsActions from '@iso/redux/localEats/actions';
import FilterModal from '@iso/components/LocalEats/filterModal/FilterModal';
import Search from '@iso/components/LocalEats/search/Search';
import DeliveryType from '@iso/components/LocalEats/deliveryType/DeliveryType';
import AboutMainModal from '@iso/components/LocalEats/aboutModals/main/AboutMainModal';

import backVideo from '@iso/assets/video/Radisson_Blue_Hotel.mp4';
import backVideoTenTen from '@iso/assets/video/tenten_1010.mp4';
import backVideolacanada from '@iso/assets/video/lacanada.mp4';
import santamonica from '@iso/assets/video/santa_monica.mp4';
import the607eatslocal from '@iso/assets/video/GettyImages-1066869278.mp4';
import pasadena from '@iso/assets/video/Pasadena_s.mp4';
import westhollywood from '@iso/assets/video/WestHollywood.mp4';
import westwood from '@iso/assets/video/Westwood.mp4';
import venicebeach from '@iso/assets/video/VENICE.mp4';
import pizzabox from '@iso/assets/video/PIZZA.mp4';

export default function () {
  const [cityNameHead, setCityNameHead] = useState('');
  const currentUrl = window.location.href;
  console.log(currentUrl);
  const url = new URL(currentUrl);
  const hostname = url.hostname;

  let dataAfterSlash;
  let city_id;
  let reorderedArray;

  if (hostname === 'localbytes.co') {
    // Extract part after the hostname
    const parts = url.pathname.split('/');
    dataAfterSlash = parts[1];
  } else if (hostname === 'lacanadaeats.com') {
    dataAfterSlash = 'lacanada';
  } else if (hostname === 'local.pizzabox.ai') {
    dataAfterSlash = 'pizzabox';
  } else if (hostname === 'coop.pizzabox.ai') {
    dataAfterSlash = 'pizzabox';
  } else if (hostname === 'the607eatslocal.com') {
    // Handle other hostname cases
    dataAfterSlash = 'the607eatslocal';
  } else if (hostname === 'syracuse.pizzabox.ai') {
    dataAfterSlash = 'pizzabox';
    city_id = 157;
  } else if (hostname === 'buffalo.pizzabox.ai') {
    dataAfterSlash = 'pizzabox';
    city_id = 158;
  } else if (hostname === 'siliconvalley.pizzabox.ai') {
    dataAfterSlash = 'pizzabox';
    city_id = 159;
  }

  function reorderArray(array, id) {
    // Find the index of the object with the given ID
    const index = array.findIndex((item) => item.id === id);
    // console.log("index", index);

    if (index !== -1) {
      // Remove the object from its current position
      const item = array.splice(index, 1)[0];
      // Add the object back to the beginning of the array
      array.unshift(item);
    }

    return array;
  }

  // const reorderedArray = reorderArray(cityArr, city_id);
  //   console.log("reorderedArray-------",reorderedArray);

  if (city_id !== null) {
    reorderedArray = reorderArray(cityArr, city_id);
  } else {
    console.log('City ID is not set. Cannot reorder array.');
    reorderedArray = cityArr;
  }

  const cityName = (id) => {
    let city = {};

    city = cityArr.find((item) => item.id === id);

    setCityNameHead(city.key);

    return city.key;
  };
  // console.log(dataAfterSlash);
  // console.log("city_id", city_id);
  const {
    marketplace = localStorage.getItem('pwaInstallPath')
      ? localStorage.getItem('pwaInstallPath')
      : dataAfterSlash,
    room = '1',
    floor,
  } = useParams();

  // console.log('marketplace', marketplace);
  localStorage.setItem('site', marketplace);
  useEffect(() => {
    if (marketplace === 'lacanadaeats.com') {
      document.title = 'La Cañada Eats';
    }

    if (marketplace === 'the607eatslocal') {
      document.title = 'The 607 Eats Local';
    }

    if (marketplace === 'pizzabox') {
      if (city_id === 157) {
        document.title = 'PizzaBox Syracuse - Best Local Pizzerias\n';
      } else if (city_id === 158) {
        document.title = 'PizzaBox Buffalo - Best Local Pizzerias\n';
      } else if (city_id === 159) {
        document.title = 'PizzaBox Silicon Valley - Best Local Pizzerias\n';
      } else {
        document.title = 'Home of the best pizza - made locally';
      }
      // document.querySelector('link[rel="icon"]').href = "@iso/assets/images/pizza-icon.png";
      const favicon = document.querySelector('link[rel="icon"]');
      if (favicon) {
        // favicon.href = "@iso/assets/images/pizza-icon.png";
        favicon.href = '/packages/isomorphic-cra/public/pizza-icon.png';
      }
    }

    if (marketplace === 'pizzabox' && city_id === 157) {
      document.title = 'PizzaBox Syracuse - Best Local Pizzerias';
    }

    if (marketplace === 'pizzabox' && city_id === 158) {
      document.title = 'PizzaBox Buffalo - Best Local Pizzerias';
    }

    if (marketplace === 'pizzabox' && city_id === 159) {
      document.title = 'PizzaBox Silicon Valley - Best Local Pizzerias';
    }

    // Cleanup function (optional)
  }, [marketplace]);
  const [cardView, setCardView] = useState(
    localStorage.getItem('card-view') || 'view3'
  );

  const [activeCategory, setActiveCategory] = useState('');
  const deviceView = useSelector((state) => state.App.view);
  const dispatch = useDispatch();
  const [query, setQuery] = useState('');
  const [queryFilter, setQueryFilter] = useState({
    id: 0,
    name: '0',
    type: '0',
  });
  const data = useSelector((state) => state.LocalEats.data);
  const brands = useSelector((state) => state.LocalEats.brands);
  const [filterBrands, setFilterBrands] = useState(brands);
  const offers = useSelector((state) => state.LocalEats.offers);
  const getProfile = useCallback(() => {
    dispatch(localEatsActions.fetchMenuFilterStart(marketplace));
    dispatch(localEatsActions.fetchMarketplaceDataStart(marketplace));
    dispatch(localEatsActions.fetchMarketplaceBrandsStart(marketplace));
    dispatch(localEatsActions.fetchMarketplaceOffersStart(marketplace));
  }, [dispatch]);

  useEffect(() => {
    if (marketplace) {
      getProfile();
    }
  }, [getProfile]);

  useEffect(() => {
    if (city_id !== null && city_id !== undefined) {
      filterBrandWithCity(city_id);
    } else {
      console.log('no brands filtered');
      setFilterBrands(brands);
    }
  }, [city_id, brands]);

  const getFilterBrands = (filters) => {
    dispatch(
      localEatsActions.fetchMarketplaceFilterBrandsStart(marketplace, filters)
    );
  };

  const filterBrandWithCity = (id) => {
    const filterBr = brands?.filter((brand) => {
      const indx = brand.filters?.findIndex((f) => f.id === id);
      if (indx !== -1 && indx !== undefined) return brand;
    });
    // console.log("filterBr-----", filterBr);
    // let filter = filterBr.filter((item) => item.brandName !== 'Pizza Zone');
    setFilterBrands(filterBr);
  };

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    variableWidth: true,
  };

  const changeCardView = (view) => {
    localStorage.removeItem('card-view');
    setCardView(view);
    localStorage.setItem('card-view', view);
  };

  const selectCategory = (category) => {
    console.log('City category', category);
    cityName(category.id);
    /*    dispatch(
          localEatsActions.fetchMarketplaceFilterBrandsStart(marketplace, [
            category,
          ])
        );*/

    setQueryFilter(category);

    if (activeCategory === category.name) {
      setActiveCategory('');
      setFilterBrands(brands);
    } else {
      setActiveCategory(category.name);
      // cityName(category.id);

      const filterBr = brands?.filter((brand) => {
        if (category?.id === 0) {
          return brand;
        } else if (category?.id !== 0) {
          const indx = brand.filters?.findIndex((f) => f.id === category?.id);
          if (indx !== -1 && indx !== undefined) return brand;
        }
      });
      let filter = filterBr.filter((item) => item.brandName !== 'Pizza Zone');
      setFilterBrands(filter);
    }
  };

  const onSearchChange = (e) => {
    setQuery(e.target.value);

    const filterBr = brands?.filter((brand) => {
      if (query === '') {
        return brand;
      } else if (
        brand?.brandName?.toLowerCase().includes(query.toLowerCase()) ||
        brand?.description?.toLowerCase().includes(query.toLowerCase()) ||
        brand?.products_name?.toLowerCase().includes(query.toLowerCase()) ||
        brand?.products_description?.toLowerCase().includes(query.toLowerCase())
      ) {
        return brand;
      }
    });
    setFilterBrands(filterBr);
  };
  if (data && brands) {
    const { city, street, houseNumber, coordinates } = data?.address;
    return (
      <>
        {/* <Helmet>
        {marketplace === "pizzabox" && (
          <>
            <title>Home of the best pizza - made locally</title>
            <link rel="icon" type="image/png" href="/packages/isomorphic-cra/public/pizza-icon.png" />
          </>
        )}
      </Helmet> */}
        <LocalEatzWrapper>
          <div
            className="homepage-header"
            style={{
              backgroundImage: `linear-gradient( rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2) ), url(${data?.title_url})`,
              // height: '100%',
              position: 'relative',
            }}
          >
            {marketplace === 'radissonblu' ? (
              <video
                id="background-video"
                autoPlay
                muted
                loop
                playsInline
                preload={'auto'}
              >
                <source src={backVideo} type="video/mp4" />
              </video>
            ) : marketplace === '1010wilshire' ? (
              <video
                id="background-video"
                autoPlay
                muted
                loop
                playsInline
                preload={'auto'}
              >
                <source src={backVideoTenTen} type="video/mp4" />
              </video>
            ) : marketplace === 'lacanada' ? (
              <video
                id="background-video"
                autoPlay
                muted
                loop
                playsInline
                preload={'auto'}
              >
                <source src={backVideolacanada} type="video/mp4" />
              </video>
            ) : marketplace === 'santa-monica' ? (
              <video
                id="background-video"
                autoPlay
                muted
                loop
                playsInline
                preload={'auto'}
              >
                <source src={santamonica} type="video/mp4" />
              </video>
            ) : marketplace === 'pasadena' ? (
              <video
                id="background-video"
                autoPlay
                muted
                loop
                playsInline
                preload={'auto'}
              >
                <source src={pasadena} type="video/mp4" />
              </video>
            ) : marketplace === 'west-hollywood' ? (
              <video
                id="background-video"
                autoPlay
                muted
                loop
                playsInline
                preload={'auto'}
              >
                <source src={westhollywood} type="video/mp4" />
              </video>
            ) : marketplace === 'venice-beach' ? (
              <video
                id="background-video"
                autoPlay
                muted
                loop
                playsInline
                preload={'auto'}
              >
                <source src={venicebeach} type="video/mp4" />
              </video>
            ) : marketplace === 'westwood' ? (
              <video
                id="background-video"
                autoPlay
                muted
                loop
                playsInline
                preload={'auto'}
              >
                <source src={westwood} type="video/mp4" />
              </video>
            ) : marketplace === 'pizzabox' ? (
              <video
                id="background-video"
                autoPlay
                muted
                loop
                playsInline
                preload={'auto'}
              >
                <source src={pizzabox} type="video/mp4" />
              </video>
            ) : marketplace === 'the607eatslocal' ? (
              <video
                id="background-video"
                autoPlay
                muted
                loop
                playsInline
                preload={'auto'}
              >
                <source src={the607eatslocal} type="video/mp4" />
              </video>
            ) : null}

            <div
              className={
                marketplace === 'pizzabox'
                  ? 'header-content-pizza'
                  : 'header-content'
              }
            >
              {marketplace === 'pizzabox' ? (
                <div className="language-selector-block-pizzabox">
                  <AboutMainModal data={data} marketplace={marketplace} />
                  {/*<LanguageSwitcher />*/}
                </div>
              ) : (
                <div className="language-selector-block">
                  <AboutMainModal data={data} marketplace={marketplace} />
                  {/*<LanguageSwitcher />*/}
                </div>
              )}

              <div className="header-top">
                {marketplace === 'pizzabox' ? (
                  <div className="homepage-header-content-pizzabox">
                    <img
                      src={data?.logo_url}
                      alt="Logo"
                      className="homepage-header-icon-pizzabox"
                    />
                    <div style={{ height: '12px' }} />
                    <span className="homepage-header-description-pizza">
                      {/* {data?.description} */}
                      Home of the best pizza... made locally
                    </span>
                    <span className="homepage-header-description-pizza-mobile">
                      {/* {data?.description} */}
                      Home of the best pizza <br />
                      ... made locally
                    </span>
                    {/* {city_id === 157 ? (
                      <p className="homepage-header-pizza-name">Syracuse, NY</p>
                    ) : city_id === 158 ? (
                      <p className="homepage-header-pizza-name">Buffalo, NY</p>
                    ) : null} */}
                    <p className="homepage-header-pizza-name">
                      {cityNameHead === ''
                        ? reorderedArray[0].key
                        : cityNameHead}
                    </p>

                    <div style={{ height: '12px' }} />
                  </div>
                ) : marketplace !== 'radissonblu' &&
                  marketplace !== 'venicebeach' &&
                  marketplace !== '1010wilshire' ? (
                  <div className="homepage-header-content">
                    <img
                      src={data?.logo_url}
                      alt="Logo"
                      className="homepage-header-icon"
                    />
                    <div style={{ height: '12px' }} />
                    <span className="homepage-header-description">
                      {data?.description}
                    </span>
                    <div style={{ height: '12px' }} />
                  </div>
                ) : (
                  <div className="homepage-header-content">
                    <img
                      src={data?.logo_url}
                      alt="Logo"
                      className="homepage-header-icon"
                    />
                    <div style={{ height: '12px' }} />
                    <span className="homepage-header-description">
                      {/*{data?.description}*/}
                    </span>
                    <div style={{ height: '12px' }} />
                  </div>
                )}
              </div>
              <DeliveryType marketplace={marketplace} />
            </div>
          </div>
          {/*
        <div className="homepage-search-block">
          <p>
            <IntlMessages id="search.label"/>
          </p>
          <Search onChange={onSearchChange}/>
        </div>
*/}
          {offers?.length !== 0 ? (
            <div className="promotions-slider">
              <Slider
                {...sliderSettings}
                infinite={true}
                autoplay={true}
                autoplaySpeed={5000}
              >
                {offers?.map(({ id, name, description, image, url }) => (
                  <PromotionItem
                    key={`${id}_${name}`}
                    img={image}
                    name={name}
                    description={description}
                    path={`https://${url}?hotel=${marketplace}&aggregator=localbytes&city=${
                      city.name
                    }
                &address=${street.name}, ${houseNumber}
                &room=${room}${floor ? `&floor=${floor}` : ''}
                &entrance=1&intercom=2
                &lat=${coordinates.latitude}&lon=${coordinates.longitude}`}
                  />
                ))}
              </Slider>
            </div>
          ) : null}

          {marketplace === 'pizzabox' ? (
            <>
              <div className="category-slider-pizza">
                <Slider
                  {...sliderSettings}
                  infinite={false}
                  autoplay={false}
                  autoplaySpeed={7000}
                >
                  {reorderedArray.map((item, index) => {
                    return (
                      <CategoryItemCity
                        key={item.key}
                        img={item.img}
                        name={item.name}
                        path={'google.com'}
                        classDisable={
                          activeCategory === item.key ||
                          (activeCategory !== '' && 'disable')
                        }
                        onClick={() =>
                          selectCategory({
                            id: item.id,
                            name: item.key,
                            type: 'city',
                          })
                        }
                      />
                    );
                  })}
                </Slider>
              </div>
            </>
          ) : marketplace != 'pizzabox' ? (
            <div className="category-slider">
              <Slider
                {...sliderSettings}
                infinite={true}
                autoplay={true}
                autoplaySpeed={7000}
              >
                <CategoryItem
                  key={'Vegan'}
                  img={categoryImg4}
                  name={<IntlMessages id="filter.vegan" />}
                  path={'google.com'}
                  classDisable={
                    activeCategory === 'Vegan' ||
                    (activeCategory !== '' && 'disable')
                  }
                  onClick={() =>
                    selectCategory({
                      id: 12,
                      name: 'Vegan',
                      type: 'diets',
                    })
                  }
                />
                <CategoryItem
                  key={'Wok'}
                  img={categoryImg3}
                  name={<IntlMessages id="filter.wok" />}
                  path={'google.com'}
                  classDisable={
                    activeCategory === 'Wok' ||
                    (activeCategory !== '' && 'disable')
                  }
                  onClick={() =>
                    selectCategory({
                      id: 37,
                      name: 'Wok',
                      type: 'dishes',
                    })
                  }
                />
                <CategoryItem
                  key={'Pizza'}
                  img={categoryImg1}
                  name={<IntlMessages id="filter.pizza" />}
                  path={'google.com'}
                  classDisable={
                    activeCategory === 'Pizza' ||
                    (activeCategory !== '' && 'disable')
                  }
                  onClick={() =>
                    selectCategory({
                      id: 28,
                      name: 'Pizza',
                      type: 'dishes',
                    })
                  }
                />
                <CategoryItem
                  key={'Sushi'}
                  img={categoryImg2}
                  name={<IntlMessages id="filter.sushi" />}
                  path={'google.com'}
                  classDisable={
                    activeCategory === 'Sushi' ||
                    (activeCategory !== '' && 'disable')
                  }
                  onClick={() =>
                    selectCategory({
                      id: 36,
                      name: 'Sushi',
                      type: 'dishes',
                    })
                  }
                />
                <CategoryItem
                  key={'Wings'}
                  img={categoryImg5}
                  name={<IntlMessages id="filter.wings" />}
                  path={'google.com'}
                  classDisable={
                    activeCategory === 'Wings' ||
                    (activeCategory !== '' && 'disable')
                  }
                  onClick={() =>
                    selectCategory({
                      id: 79,
                      name: 'Wings',
                      type: 'dishes',
                    })
                  }
                />
                <CategoryItem
                  key={'Burgers'}
                  img={categoryImg}
                  name={<IntlMessages id="filter.burgers" />}
                  path={'google.com'}
                  classDisable={
                    activeCategory === 'Burgers' ||
                    (activeCategory !== '' && 'disable')
                  }
                  onClick={() =>
                    selectCategory({
                      id: 20,
                      name: 'Burgers',
                      type: 'dishes',
                    })
                  }
                  /*              onClick={() => setQueryFilter({
                                    id: 20,
                                    name: 'Burgers',
                                    type: 'dishes',
                                  })}*/
                />
                <CategoryItem
                  key={'Mac-n-Cheese'}
                  img={categoryImg6}
                  name={<IntlMessages id="filter.macNCheese" />}
                  path={'google.com'}
                  classDisable={
                    activeCategory === 'Mac-n-Cheese' ||
                    (activeCategory !== '' && 'disable')
                  }
                  onClick={() =>
                    selectCategory({
                      id: 80,
                      name: 'MacNCheese',
                      type: 'dishes',
                    })
                  }
                />
              </Slider>
            </div>
          ) : null}

          {deviceView === 'MobileView' && (
            <div className="homepage-search-block homepage-search-block-variant-2">
              <Search onChange={onSearchChange} />
            </div>
          )}

          <div className="restaurant-item-controls">
            <FilterModal getFilterBrands={getFilterBrands} />

            {deviceView !== 'MobileView' && (
              <div className="homepage-search-block">
                <Search onChange={onSearchChange} />
              </div>
            )}

            <div className="all-btn-container">
              <div
                className="all-button"
                onClick={() => setFilterBrands(brands)}
              >
                Show All
              </div>
            </div>

            {/* <div className="card-view-controls-block">
              <div
                className={`card-view-control-item ${
                  cardView === 'view1' && 'active'
                }`}
                onClick={() => changeCardView('view1')}
              >
                <img src={cardViewImage1} alt="" />
              </div>
              <div
                className={`card-view-control-item ${
                  cardView === 'view2' && 'active'
                }`}
                onClick={() => changeCardView('view2')}
              >
                <img src={cardViewImage2} alt="" />
              </div>
              <div
                className={`card-view-control-item ${
                  cardView === 'view3' && 'active'
                }`}
                onClick={() => changeCardView('view3')}
              >
                <img src={cardViewImage3} alt="" />
              </div>
            </div> */}
          </div>

          <div className="restaurant-block">
            <div className="custom-container ant-row">
              {filterBrands?.length !== 0 ? (
                filterBrands?.map(
                  (
                    {
                      id,
                      brandName,
                      filters,
                      cover_image,
                      wl_url,
                      url,
                      description,
                      delivery_type,
                      is_work,
                      delivery_time,
                      cost,
                    },
                    index
                  ) => (
                    // {brandName === "Pizza Zone" ? null : (

                    // )}
                    <div
                      key={index + '_' + brandName + '_' + id}
                      className={`ant-col restaurant-col ${
                        cardView === 'view1'
                          ? 'ant-col-xs-12 ant-col-sm-12 ant-col-lg-6 ant-col-xl-4'
                          : 'ant-col-xs-24 ant-col-sm-12 ant-col-lg-12 ant-col-xl-8'
                      }`}
                    >
                      <RestaurantItem
                        index={index}
                        view={cardView}
                        name={brandName}
                        mainImg={cover_image}
                        smallImg={url}
                        shortDescription={filters}
                        description={description}
                        isWork={is_work}
                        deliveryMethod={delivery_type}
                        closed={true}
                        cost={cost}
                        time={
                          parseInt(delivery_time) !== 0
                            ? `${delivery_time} min`
                            : '25 min'
                        }
                        path={
                          `https://${wl_url}?hotel=${marketplace}&aggregator=localbytes&city=${city.name}` +
                          `&address=${street.name}, ${houseNumber}` +
                          `&room=${room}${floor ? `&floor=${floor}` : ''}` +
                          `&entrance=1&intercom=2` +
                          `&lat=${coordinates.latitude}&lon=${coordinates.longitude}`
                        }
                      />
                    </div>
                  )
                )
              ) : (
                <h3 style={{ width: '100%', textAlign: 'center' }}>
                  <IntlMessages id="general.noRestaurants" /> :(
                </h3>
              )}
            </div>
          </div>

          <Footer marketplace={marketplace} />
        </LocalEatzWrapper>
      </>
    );
  } else {
    return (
      <div
        style={{
          minHeight: '150px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spin />
      </div>
    );
  }
}
